<canvas #canvas [id]="chartId">{{ chart }}</canvas>
